import { useAuthStore } from '@/state/authState';

export function resolveRepositoryProvider(provider: string): {
  provider: 'github' | 'gitlab' | 'bitbucket';
  baseUrl?: string;
} | null {
  if (
    provider === 'github' ||
    provider === 'gitlab' ||
    provider === 'bitbucket'
  ) {
    return { provider };
  }

  const { providers } = useAuthStore.getState();
  const registered: unknown = Object.hasOwn(providers, provider)
    ? providers[provider]
    : undefined;
  if (
    registered &&
    typeof registered === 'object' &&
    'id' in registered &&
    registered.id === provider &&
    'isSelfHosted' in registered &&
    registered.isSelfHosted === true &&
    'baseUrl' in registered &&
    typeof registered.baseUrl === 'string' &&
    registered.baseUrl.trim()
  ) {
    return { provider: 'gitlab', baseUrl: registered.baseUrl.trim() };
  }
  return null;
}
